import * as firebase from 'firebase/app';
import 'firebase/auth';
import firebaseConfig from './firebaseConfig';

class Auth {
    constructor() {
        this.firebaseApp = firebase.initializeApp(firebaseConfig);
        this.googleAuthProvider = new firebase.auth.GoogleAuthProvider();
        this.googleAuthProvider.addScope('profile');
        this.googleAuthProvider.addScope('email');

        this.getProfile = this.getProfile.bind(this);
        this.getIdToken = this.getIdToken.bind(this);
        this.signIn = this.signIn.bind(this);
        this.signOut = this.signOut.bind(this);
        this.setCallback = this.setCallback.bind(this);
    }

    getProfile() {
        return this.profile;
    }

    setCallback(callback) {
        this.parentCallback = callback;
        firebase.auth().onAuthStateChanged(function (user) {
            if (user) {
                authClient.profile = user;
                user.getIdToken().then(function (result) {
                    authClient.idToken = result;
                    if (authClient.parentCallback) {
                        authClient.parentCallback();
                    }
                });
            } else {
                if (authClient.parentCallback) {
                    authClient.parentCallback();
                }
            }
        });
    }

    getIdToken() {
        return this.idToken;
    }

    signIn() {
        this.firebaseApp.auth().signInWithPopup(this.googleAuthProvider).then(function (result) {
            authClient.profile = result.additionalUserInfo.profile;
            console.log(result);

            return result.user.getIdToken().then(function (result) {
                console.log(result);
                authClient.idToken = result;
                if (authClient.parentCallback) {
                    authClient.parentCallback();
                }
            });
        });
    }

    signOut() {
        // clear id token, profile, and expiration
        this.firebaseApp.auth().signOut();
        this.idToken = null;
        this.profile = null;
    }
}

const authClient = new Auth();

export default authClient;